import { NavLink } from "react-router-dom";
import RouteConfig from "../system/routes";
import { useEffect, useState } from "react";
import { clearStorage, getUserData, SCREENS_IDS } from "../system";
import { useNavigate } from "react-router-dom";
import ProfileModal from "./ProfileModal";
import { userActions } from "../redux/actions";
import { useDispatch } from "react-redux";

const SharedSidebar = () => {
  const [screens, setScreens] = useState([]);
  const dispatch = useDispatch();
const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const Logout = (e) => {
    // e.preventDefault();
    dispatch(userActions.logout());
  };
  useEffect(() => {
      let filteredScreens;
      filteredScreens = RouteConfig.PrivateRoutes
      setScreens(filteredScreens);
  }, []);

  return (
    <div className="app-menu navbar-menu">
      <ProfileModal  show={showModal}
                          onHide={() => setShowModal(false)}/>
      <div className="navbar-brand-box">
        <NavLink to="/" className="logo logo-dark">
        {/* <h2 className="text-dark m-0 p-0">{process.env.REACT_APP_NAME}</h2> */}
          <img src="assets/images/digitalLogo.png" alt="digitalLogo" height={45} />
        </NavLink>
      </div>

      {/* menu list */}
      <div id="scrollbar">
        <div className="container-fluid pt-4 ps-0">
          <ul className="navbar-nav app-menu-list" id="navbar-nav">
            {screens.map((route, idx) => (
              <li className="nav-item" key={idx}>
                <NavLink
                  to={route.path}
                  end
                  className={({ isActive }) =>
                    `nav-link menu-link pill-link ${isActive ? "active" : ""}`
                  }
                >
                  <i className={route.icon} />
                  <span>{route.name}</span>
                </NavLink>
              </li>
            ))}
          </ul>
           <ul
              className="navbar-nav app-menu-list bottom-fixed"
              id="navbar-nav"
            >
              <li className="nav-item" key="profile">
                <NavLink
                  to=""
                  onClick={() => Logout()}
                  end
                  className={({ isActive }) =>
                    `nav-link menu-link pill-link ${isActive ? "" : ""}`
                  }
                >
                  <i className="mdi mdi-logout" />
                  <span>Logout</span>
                </NavLink>
              </li>
            </ul>
        </div>
      </div>
    </div>
  );
};

export default SharedSidebar;
